import { apiClient } from "@/services/apiClient";
import {
  CreateResourceComplianceHelpQuestionRequest,
  ResourceComplianceHelpContent,
  ResourceComplianceHelpfulVoteResult,
  ResourceComplianceHelpItem,
} from "@/types/resourceComplianceHelp";

function mapQuestion(item: any): ResourceComplianceHelpItem {
  return {
    id: item.questionId,
    source: item.source === "community" ? "community" : "faq",
    category: item.category || "General",
    questionText: item.questionText,
    answerText: item.answerText || "Pending answer.",
    createdDt: item.createDt,
    displayName: item.displayAsAnonymous ? "Anonymous" : item.askedByDisplayName || item.askedByUser || item.askedByEmail,
    askedByDisplayName: item.askedByDisplayName,
    askedByEmail: item.askedByEmail,
    displayAsAnonymous: item.displayAsAnonymous,
    isPublic: item.isPublic,
    isAnswered: item.isAnswered,
    helpfulCount: item.helpfulCount,
    hasUserVotedHelpful: item.hasUserVotedHelpful,
    sortOrder: item.sortOrder,
  };
}

export async function getResourceComplianceHelpContent(): Promise<ResourceComplianceHelpContent> {
  const res = await apiClient.get<any[]>("/api/resource-compliance/help/public");
  const mapped = res.data.map(mapQuestion);

  return {
    faqs: mapped.filter((item) => item.source === "faq"),
    communityQuestions: mapped.filter((item) => item.source === "community"),
  };
}

export async function submitResourceComplianceHelpQuestion(
  request: CreateResourceComplianceHelpQuestionRequest
): Promise<ResourceComplianceHelpItem> {
  const res = await apiClient.post<any>("/api/resource-compliance/help/questions", request);
  return mapQuestion(res.data);
}

export async function markResourceComplianceQuestionHelpful(questionId: number): Promise<ResourceComplianceHelpfulVoteResult> {
  const res = await apiClient.post<any>(`/api/resource-compliance/help/questions/${questionId}/helpful`);
  return {
    questionId: res.data.questionId,
    helpfulCount: res.data.helpfulCount,
    hasUserVotedHelpful: res.data.hasUserVotedHelpful,
    voteRecorded: res.data.voteRecorded,
  };
}
